import { urlWithParams } from '@marketplace-web/shared/url-util'
import { AccessChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'

const URL_REGEX = /https?:\/\/[^\s/$.?#].[^\s"'>]*/g
const HELP_CENTER_URL = '/help'

export const getContentWithThreadId = (
  content: string,
  threadId: Array<string> | string | undefined,
) => {
  return content.replace(URL_REGEX, (url: string) => {
    if (!url.includes(HELP_CENTER_URL)) {
      return url
    }

    return urlWithParams(url, {
      access_channel: AccessChannel.HcTopics,
      thread_id: threadId,
    })
  })
}
